<template>
  <q-card class="inhdialog-container counterparty-change-dialog">
    <div class="inhdialog-header">
      <h1 class="dialog_name">{{ $t("linked_to_client") }}</h1>
      <q-btn
        flat
        round
        icon="close"
        size="md"
        color="accent"
        :title="$t('close_label')"
        @click="close"
      />
    </div>

    <div class="dialog_content">
      <div class="inner_container">
        <div class="field-group">
          <div class="field-group__row no-wrap justify-left">
            <div class="bold-name mr-xs">{{ $t("linked_to_client") }}:</div>
            <span>{{ currentClientLabel }}</span>
          </div>
        </div>

        <div class="field-group">
          <div class="field-group__row no-wrap justify-left">
            <div class="bold-name mr-xs">{{ $t("client_for_counterparty") }}:</div>
            <span>{{ newClientLabel }}</span>
          </div>
        </div>

        <div class="field-group">
          <aux-selector
            :model-type="27"
            :input-index="0"
            :allow-multiple="false"
            v-model="tmp_cp_clients"
          />
        </div>

        <div class="reattach-actions row no-wrap justify-end q-mt-sm q-mr-md">
          <q-btn no-caps flat :label="$t('cancel')" color="dark" @click="close" />
          <q-btn
            no-caps
            class="q-ml-sm"
            :label="$t('attach')"
            color="primary"
            :disable="!canBind"
            @click.stop="bind"
          />
        </div>
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-facing-decorator";
import { QBtn } from "quasar";
import { reactive } from "vue";
import _ from "lodash";
// import AuxSelector from "@/components/common/aux-selector/AuxSelector.vue";
import { financesStore } from "@/store/finances";
import { CommonEntity } from "../../../../models/interfaces/common";

@Component({
  components: {
    QBtn,
  },
  emits: ["close", "done"],
})
export default class CounterpartyChangeDialog extends Vue {
  @Prop({ type: Number, default: 0 }) readonly counterpartyId!: number;
  @Prop({ type: Number, default: 0 }) readonly currentClientId!: number;
  @Prop({ type: String, default: "" }) readonly currentClientName!: string;

  finStore: any | undefined = undefined;

  tmp_cp_clients: CommonEntity[] = reactive([]);
  selectedNewClient: CommonEntity | undefined = undefined;

  created() {
    this.finStore = financesStore();
  }

  get tmp_cp_clients_mut() {
    return _.cloneDeep(this.tmp_cp_clients);
  }

  get currentClientLabel() {
    const name = this.currentClientName || '';
    return `${name}`;
  }

  get newClientLabel() {
    if (!this.selectedNewClient) return '';
    return `${this.selectedNewClient.Name}`;
  }

  get canBind() {
    if (!this.selectedNewClient?.Id) return false;
    // Клиент, к которому КА привязан сейчас, перепривязке не подлежит.
    if (this.currentClientId && this.selectedNewClient.Id === this.currentClientId) return false;
    return true;
  }

  @Watch("tmp_cp_clients_mut")
  onNewClientSelected(newval: any, oldval: any) {
    if (!this.tmp_cp_clients_mut.length || _.isEqual(newval, oldval)) {
      if (!this.tmp_cp_clients_mut.length) {
        this.selectedNewClient = undefined;
      }
      return;
    }

    const tmp_cp: CommonEntity =
      this.tmp_cp_clients_mut[this.tmp_cp_clients_mut.length - 1];
    if (tmp_cp) {
      this.selectedNewClient = _.cloneDeep(tmp_cp);
    }
    this.tmp_cp_clients = reactive([
      this.tmp_cp_clients_mut[this.tmp_cp_clients_mut.length - 1],
    ]);
  }

  @Emit('close')
  close() {}

  @Emit("done")
  done() {
    return null;
  }

  async bind() {
    if (!this.canBind || !this.selectedNewClient?.Id) return;

    await this.finStore.reattachCounterparty({
      counterpartyId: this.counterpartyId,
      clientId: this.selectedNewClient.Id,
    });

    this.done();
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 480px) {
  .counterparty-change-dialog {
    width: 100vw !important;
    max-width: none !important;
    height: 100vh !important;
    height: 100dvh !important;
    max-height: none !important;
    border-radius: 0 !important;

    .dialog_content {
      display: flex;
      min-height: 0;
    }

    .inner_container {
      flex: 1;
      min-height: 0;
    }

    .reattach-actions {
      margin-top: auto !important;
      padding: 12px 0;
    }
  }
}
</style>
